import { isPrerender } from './prerender'

const baseSize = 16
function setRem() {
    const scale = document.documentElement.clientWidth / 1920
    document.documentElement.style.fontSize = Math.max(baseSize * scale, 12) + 'px'
}

if (!isPrerender()) {
    setRem()
    window.addEventListener('resize', setRem)
}
